import React, { memo } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { SVG_COMPONENTS } from '@/assets/admin';
import { TAG_PRESET_COLORS } from '@/constants/residents/corkBoardConstants';
import { useAdminColors } from '@/hooks/admin/useAdminColors';

interface TagColorPickerProps {
  selectedColor: string | null;
  onSelectColor: (color: string | null) => void;
}

export const TagColorPicker: React.FC<TagColorPickerProps> = memo(({ selectedColor, onSelectColor }) => {
  const { redesign } = useAdminColors();

  return (
    <View style={styles.container}>
      <Text style={[styles.label, { color: redesign.text.secondary }]}>Color</Text>
      <View style={styles.grid}>
        {TAG_PRESET_COLORS.map((color) => {
          const isSelected = selectedColor === color;
          return (
            <TouchableOpacity
              key={color}
              style={[
                styles.swatch,
                { backgroundColor: color },
                isSelected && [styles.swatchSelected, { borderColor: redesign.text.primary }],
              ]}
              onPress={() => onSelectColor(isSelected ? null : color)}
              activeOpacity={0.7}
              accessibilityLabel={`Color ${color}`}
              accessibilityRole="radio"
              accessibilityState={{ selected: isSelected }}
            >
              {isSelected && <SVG_COMPONENTS.CHECK_CIRCLE width={16} height={16} color="#FFFFFF" />}
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
});

TagColorPicker.displayName = 'TagColorPicker';

const styles = StyleSheet.create({
  container: {
    gap: 8,
  },
  label: {
    fontSize: 13,
    fontWeight: '500',
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  swatch: {
    width: 36,
    height: 36,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  swatchSelected: {
    borderWidth: 2,
  },
});
